// src/components/Footer/Footer.jsx

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Grid,
  Typography,
  Link,
  Box,
  Button,
  IconButton,
  Tooltip,
  Stack,
} from '@mui/material';
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  YouTube as YouTubeIcon,
} from '@mui/icons-material';

const Footer = () => {
  return (
    <>
      {/* Seção de CTA */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          py: 8,
          my: 8,
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            Pronto para Transformar seu Processo de Inscrição?
          </Typography>
          <Typography variant="h6" align="center" paragraph>
            Junte-se a milhares de instituições e estudantes que já estão usando o ZenKroll.
          </Typography>
          <Box display="flex" justifyContent="center" mt={4} flexDirection={{ xs: 'column', sm: 'row' }}>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              component={RouterLink}
              to="/leads" // Atualizado para direcionar para o formulário de demonstração
              sx={{
                mr: { sm: 2 },
                mb: { xs: 2, sm: 0 },
                borderRadius: '24px',
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                },
              }}
            >
              Comece Gratuitamente
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              component={RouterLink}
              to="/leads" // Atualizado para direcionar para o formulário de demonstração
              sx={{
                borderColor: 'primary.contrastText',
                color: 'primary.contrastText',
                borderRadius: '24px',
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                },
              }}
            >
              Agendar uma Demo
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Container maxWidth="lg" component="footer" sx={{ mt: 8, py: 4, bgcolor: 'grey.100', borderRadius: '16px' }}>
        <Grid container spacing={4} justifyContent="space-evenly">
          <Grid item xs={6} sm={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Sobre
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link
                  component={RouterLink}
                  to="/quem-somos"
                  color="text.secondary"
                  underline="hover"
                >
                  Quem Somos
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to="/nossa-equipe"
                  color="text.secondary"
                  underline="hover"
                >
                  Nossa Equipe
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to="/carreiras"
                  color="text.secondary"
                  underline="hover"
                >
                  Carreiras
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contactos
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link
                  component={RouterLink}
                  to="/suporte"
                  color="text.secondary"
                  underline="hover"
                >
                  Suporte
                </Link>
              </li>
              <li>
                <Link
                  href="mailto:contato@zenkroll.com"
                  color="text.secondary"
                  underline="hover"
                >
                  Email
                </Link>
              </li>
              <li>
                <Link
                  href="tel:+258846031855"
                  color="text.secondary"
                  underline="hover"
                >
                  Telefone
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Legal
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link
                  component={RouterLink}
                  to="/privacidade"
                  color="text.secondary"
                  underline="hover"
                >
                  Privacidade
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to="/termos-de-uso"
                  color="text.secondary"
                  underline="hover"
                >
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to="/faq"
                  color="text.secondary"
                  underline="hover"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Recursos
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link
                  component={RouterLink}
                  to="/blog"
                  color="text.secondary"
                  underline="hover"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to="/centro-de-ajuda"
                  color="text.secondary"
                  underline="hover"
                >
                  Centro de Ajuda
                </Link>
              </li>
              <li>
                <Link
                  component={RouterLink}
                  to="/parceiros"
                  color="text.secondary"
                  underline="hover"
                >
                  Parceiros
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>

        {/* Redes Sociais */}
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" color="text.primary" gutterBottom sx={{ textAlign: 'center', mb: 2 }}>
            Siga-nos nas Redes Sociais
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Tooltip title="Facebook">
              <IconButton
                component="a"
                href="https://www.facebook.com/seu-perfil" // Substitua pelo link real
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                sx={{
                  color: '#3b5998',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.2)',
                    color: '#2d4373',
                  },
                }}
              >
                <FacebookIcon fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Instagram">
              <IconButton
                component="a"
                href="https://www.instagram.com/seu-perfil" // Substitua pelo link real
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                sx={{
                  color: '#E1306C',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.2)',
                    color: '#C13584',
                  },
                }}
              >
                <InstagramIcon fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="LinkedIn">
              <IconButton
                component="a"
                href="https://www.linkedin.com/in/seu-perfil" // Substitua pelo link real
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                sx={{
                  color: '#0e76a8',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.2)',
                    color: '#005983',
                  },
                }}
              >
                <LinkedInIcon fontSize="large" />
              </IconButton>
            </Tooltip>
            <Tooltip title="YouTube">
              <IconButton
                component="a"
                href="https://www.youtube.com/seu-canal" // Substitua pelo link real
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                sx={{
                  color: '#FF0000',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.2)',
                    color: '#CC0000',
                  },
                }}
              >
                <YouTubeIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>

        {/* Rodapé */}
        <Box sx={{ mt: 5 }}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} ZenKroll. Todos os direitos reservados.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default Footer;
